import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=4c8cf658&scoped=true"
import script from "./ChatList.vue?vue&type=script&lang=js"
export * from "./ChatList.vue?vue&type=script&lang=js"
import style0 from "./ChatList.vue?vue&type=style&index=0&id=4c8cf658&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cf658",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8cf658')) {
      api.createRecord('4c8cf658', component.options)
    } else {
      api.reload('4c8cf658', component.options)
    }
    module.hot.accept("./ChatList.vue?vue&type=template&id=4c8cf658&scoped=true", function () {
      api.rerender('4c8cf658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/ChatList.vue"
export default component.exports